// extracted by mini-css-extract-plugin
module.exports = {"iconBtn":"styles_iconBtn__1om1u","modal-footer":"styles_modal-footer__ddbRF","btn":"styles_btn__3k0yd","right-aligned":"styles_right-aligned__3FWuQ"};